import { format as formatDateFns, parseISO } from 'date-fns'
import { formatInTimeZone } from 'date-fns-tz'
import { formatMoney } from './money'

// Keep formatAmount as alias for backward compatibility but use formatMoney
export const formatAmount = (amount: number, currency: string | null) => {
  return formatMoney(amount, currency || 'USD')
}

export const formatDate = (dateInput: string | Date, format: string = 'locale') => {
  const date = dateInput instanceof Date ? dateInput : parseISO(dateInput)

  if (format === 'locale') {
    return date.toLocaleString()
  }

  return formatDateFns(date, format)
}

const toDate = (dateInput: Date | string): Date =>
  dateInput instanceof Date ? dateInput : parseISO(dateInput)

export const formatInTz = (
  dateInput: Date | string,
  format: string,
  timezone: string,
): string => {
  const date = toDate(dateInput)
  try {
    return formatInTimeZone(date, timezone, format)
  } catch (error) {
    // Unknown IANA identifier or malformed input — never crash a table row.
    console.warn(`formatInTz: invalid timezone "${timezone}" — falling back to UTC`, error)
    return formatInTimeZone(date, 'UTC', format)
  }
}
